<template>
  <div v-if="data && list.length" class="header-notification-pos notification-block">
    <div class="notification-content">
      <ul v-if="list.length" class="items">
        <li><strong>{{ data.title }}:</strong> {{ list[0] }}&nbsp;</li>
        <li v-for="item in list.slice(1, list.length - 1)" :key="item">{{ item }}</li>
        <li class="last">{{ list[list.length - 1] }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { Dialog } from "element-ui";
export default {
  name: "NewsBanner",

  components: {
    ElDialog: Dialog
  },

  data() {
    return {
      data: null,
      list: []
    }
  },

  created() {
    this.getData();
  },

  methods: {
    getData() {
      this.$http
        .post("banners/login-banner",
          {
            method: "GET"
          }
        )
        .then(
          response => {
            if (response && response.data) {
              if (response.data.error) {
                this.notification(
                  response.data.message,
                  "pan_tool",
                  "danger"
                );
              } else {
                this.data = response.data;
                this.list = response.data.description && response.data.description.split("-").filter(item => item)
              }
            } else {
              this.notification(
                "Something went wrong. Please try again.",
                "pan_tool",
                "danger"
              );
            }
          },
          error => {
            this.notification(error.message, "pan_tool", "danger");
          }
        );
    },
    notification(message, icon, color) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "right",
        verticalAlign: "top",
        type: color
      });
    },
  }
};
</script>

<style lang="scss">
.notification-block {
  position: fixed;
  background-color: #d95260;
  padding: 4px 6px;
  font-size: 15px;
  z-index: 1000;
  width: 100%;
  text-align: center;
  color: #fff;
}

.header-notification-pos {
  top: 0px;
}
ul.items {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
ul.items li { display: inline; white-space: nowrap; }
ul.items li:after {
  content: " • ";
}
ul.items li.nobullet:after { content: none; }
ul.items li.last:after {
  content: "";
}

@media (max-width: 480px), (max-width: 767px), (max-width: 992px), (max-width: 1100px){
  .notification-content {
    -moz-animation: marquee 20s linear infinite;
    -webkit-animation: marquee 20s linear infinite;
    animation: marquee 20s linear infinite;
  }

  @-moz-keyframes marquee {
    0% { transform: translateX(1000px); }
    100% { transform: translateX(-1000px); }
  }
  @-webkit-keyframes marquee {
    0% { transform: translateX(1000px); }
    100% { transform: translateX(-1000px); }
  }
  @keyframes marquee {
    0% {
      -moz-transform: translateX(1000px);
      -webkit-transform: translateX(1000px);
      transform: translateX(1000px) }
    100% {
      -moz-transform: translateX(-1000px);
      -webkit-transform: translateX(-1000px);
      transform: translateX(-1000px); }
  }
}
</style>
